// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3f48a26e] .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th{border:none}.mtitle[data-v-3f48a26e]{color:#00475a;margin-bottom:5px;margin-top:20px;font-weight:bolder}.mtitle[data-v-3f48a26e],.value[data-v-3f48a26e]{font-size:16px}.data[data-v-3f48a26e]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
